const React = require('react');

const Arrow = () => (
  <svg width="17" height="18" viewBox="0 0 17 18">
    <g fill="none" fillRule="evenodd" stroke="#3483FA" strokeWidth="1.5">
      <path d="M9 1.458L1.458 9 9 16.542M1.667 9h14.666" />
    </g>
  </svg>
);

module.exports = Arrow;
